"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterList = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var FilterList = function (_a) {
    var label = _a.label, allFilters = _a.filters, onFilterDelete = _a.onFilterDelete, onAllFilterDelete = _a.onAllFilterDelete;
    var filterElements = [];
    allFilters.forEach(function (_a) {
        var name = _a.name, filters = _a.filters;
        filters
            .filter(function (f) { return f.selected && f.type !== "all"; })
            .forEach(function (f) {
            var filterPrefix = f.type === "category" ? "".concat(name.toLowerCase(), ":") : "";
            filterElements.push(react_1.default.createElement("div", { key: f.id, className: "mx-1 text-blue-dark" },
                react_1.default.createElement("span", null, "".concat(filterPrefix).concat(f.label)),
                react_1.default.createElement("button", { onClick: function () {
                        return onFilterDelete &&
                            onFilterDelete(name, __assign(__assign({}, f), { selected: false }));
                    } },
                    react_1.default.createElement(_1.InlineIcon, { name: "close-square", className: "w-3 h-3 text-blue-dark" }))));
        });
    });
    var filterCount = filterElements.length;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && filterCount > 0 && react_1.default.createElement("p", { className: "text-grey-darker" }, label),
        react_1.default.createElement("div", { className: "flex -mx-1 flex-wrap leading-normal" },
            filterElements,
            filterCount > 0 && (react_1.default.createElement("div", { className: "mx-1 text-blue-dark" },
                react_1.default.createElement("span", null, "Clear all"),
                react_1.default.createElement("button", { onClick: function () { return onAllFilterDelete && onAllFilterDelete(); } },
                    react_1.default.createElement(_1.InlineIcon, { name: "close-square", className: "w-3 h-3 text-blue-dark" })))))));
};
exports.FilterList = FilterList;
